import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ReportsService } from 'src/app/services/reports.service';

// import * as jspdf from 'jspdf';
// import html2canvas from 'html2canvas';

@Component({
  selector: 'app-showbookingreport',
  templateUrl: './showbookingreport.component.html',
  styleUrls: ['./showbookingreport.component.scss']
})
export class ShowBooingReportComponent implements OnInit {
  routeParams: any;
  reportUrl: any;
  submitbtn: string;
  title: string;

  @Input()
  url: SafeResourceUrl;
  src: string;
  pdfSource: any;
  src1: any;
  loading = true;

  constructor(
    private reportService: ReportsService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ShowBooingReportComponent>,
    public sanitizer: DomSanitizer
  ) {
  }

  ngOnInit() {
    this.data.downloadType = 4;
    this.reportService.tripreport(this.data).subscribe(result => {
      if (result) {
        // this.pdfSource = result;
        //  const dt = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + result + '#toolbar=1&navpanes=0');
        // this.src = 'data:text/html;base64,' + result;
        // setTimeout(() => {
        //   this.src = 'data:text/html;base64,' + result;
        // }, 1000);

        const decodedString = this.base64DecodeUnicode(result);
        this.src1 = this.sanitizer.bypassSecurityTrustHtml(decodedString);

        // const decodedStringAtoB = atob(result);
        // this.src1 = this.sanitizer.bypassSecurityTrustHtml(decodedStringAtoB);
        this.loading = false;
        // this.src = decodedStringAtoB;
      }
    });
  }

  base64DecodeUnicode(base64String: string): string {
    const binaryString = atob(base64String);
    const byteNumbers = new Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      byteNumbers[i] = binaryString.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const decodedString = new TextDecoder('utf-8').decode(byteArray);
    return decodedString;
  }

  // downloadpdf() {
  //   // this.generatePDF();
  //   // const linkSource = 'data:text/html;base64, ' + this.pdfSource;
  //   const linkSource = 'data:application/pdf;base64, ' + this.pdfSource;
  //   const downloadLink = document.createElement('a');
  //   const fileName = 'tripreport.pdf';
  //   // const fileName = 'tripreport.html';

  //   downloadLink.href = linkSource;
  //   downloadLink.download = fileName;
  //   downloadLink.click();
  // }

  downloadpdf() {
    const pdfdata = this.data;
    pdfdata.downloadType = 1;
    this.reportService.tripreport(pdfdata).subscribe(result => {
      if (result) {
        this.pdfSource = result;
        const linkSource = 'data:application/pdf;base64, ' + result;
        const downloadLink = document.createElement('a');
        const fileName =this.data.reportType== 61 ?'PACCS Status Details Report.pdf':this.data.ReportType == 55 ?'Farmer Cultivation Details Report.pdf': 'Booking Detail Report.pdf';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });
  }

  downloadexcel() {
    const printdata = this.data;
    printdata.downloadType = 2;
    this.reportService.tripreport(printdata).subscribe(result => {
      if (result) {
        const linkSource = 'data:application/vnd.ms-excel;base64, ' + result;
        const downloadLink = document.createElement('a');
        const fileName =this.data.reportType== 61 ?'PACCS Status Details Report.xls': this.data.reportType == 47 ?(this.data.ServiceProviderType == 4 ? 'PACCS with District.xlsx' : this.data.ServiceProviderType == 5 ? 'Private with District.xlsx' : this.data.ServiceProviderType == 3 ? 'PACCS District Implement Added Report.xlsx' : 'Private District Implement Added Report.xlsx'):this.data.ReportType == 55 ?'Farmer Cultivation Details Report.xls': 'Booking Detail Report.xls';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });
  }

  downloadhtml() {
    const printdata = this.data;
    printdata.downloadType = 4;
    this.reportService.tripreport(printdata).subscribe(result => {
      if (result) {
        const linkSource = 'data:text/html;base64, ' + result;
        const downloadLink = document.createElement('a');
        const fileName =this.data.reportType== 61 ?'PACCS Status Details Report.html': this.data.reportType == 47 ?'District Wise Implement Added Report.html':this.data.ReportType == 55 ?'Farmer Cultivation Details Report.html':'Booking Detail Report.html';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });
  }

  downloadword() {
    const worddata = this.data;
    worddata.downloadType = 3;
    this.reportService.tripreport(worddata).subscribe(result => {
      if (result) {
        const linkSource = 'data:application/msword;base64, ' + result;
        const downloadLink = document.createElement('a');
        const fileName =this.data.reportType== 61 ?'PACCS Status Details Report.doc': this.data.ReportType == 55 ?'Farmer Cultivation Details Report.doc':'Booking Detail Report.doc';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });
  }

  print() {
    const exceldata = this.data;
    exceldata.downloadType = 1;
    this.reportService.tripreport(exceldata).subscribe(result => {
      if (result) {
        this.printPreview(result);
      }
    });
  }

  printPreview = (data, type = 'application/pdf') => {
    let blob = null;
    blob = this.b64toBlob(data, type);
    const blobURL = URL.createObjectURL(blob);
    const theWindow = window.open(blobURL);
    const theDoc = theWindow.document;
    const theScript = document.createElement('script');
    function injectThis() {
      window.print();
    }
    theScript.innerHTML = `window.onload = ${injectThis.toString()};`;
    theDoc.body.appendChild(theScript);
  };

  b64toBlob = (content, contentType) => {
    contentType = contentType || '';
    const sliceSize = 512;
    // method which converts base64 to binary
    const byteCharacters = window.atob(content);

    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {
      type: contentType
    }); // statement which creates the blob
    return blob;
  };

  onCancel() {
    this.dialogRef.close();
  }

  close(isProceed) {
    this.dialogRef.close(isProceed);
  }

}
